import React, { createContext } from 'react';
export const ModalInternalContext = createContext({
    // By default, clicking outside the modal closes it. However, when you have
    // multiple modals stacked, the lower ones should not close whenever there
    // are clicks.
    canOutsideClickClose: true,
});
ModalInternalContext.displayName = 'ModalInternalContext';
//# sourceMappingURL=ModalInternalContext.js.map